// In assets/js/vendors/klaviyo.js
window.Theme = window.Theme || {};

Theme.KlaviyoIntegration = (function() {
  function initTracking() {
    // Initialize Klaviyo tracking
    window._learnq = window._learnq || [];
    
    // Find Add to Cart buttons
    var addToCartBtn = document.getElementById('AddToCart');
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function() {
        // Get the current product information
        var productData = getProductData();
        window._learnq.push(['track', 'Added to Cart', productData]);
      });
    }
  }
  
  function getProductData() {
    // Extract product data for Klaviyo tracking
    // This will need to pull in product details - modify as needed
    return {
      // Product details for Klaviyo
      id: document.querySelector('[data-product-id]')?.getAttribute('data-product-id'),
      title: document.querySelector('[data-product-title]')?.getAttribute('data-product-title'),
      // Add other required fields
    };
  }
  
  function initReviews() {
    // Initialize Klaviyo reviews (if needed)
  }
  
  function init() {
    initTracking();
    initReviews();
  }
  
  return {
    init: init
  };
})();